// El auditorio: quién está ahora mismo, y el emoji que se puede decir.
//
// POR SONDEO Y NO POR SOCKET. La norma de la casa es no usar websockets y aquí no cuesta
// nada respetarla: no hay posiciones que transmitir —los sitios los reparte el cliente por
// el orden de la lista— y lo único que quiere parecer instantáneo es un emoji, al que dos
// segundos de retraso no se le notan. Desde el 13 de septiembre de 2026 viaja además EL SITIO,
// una etiqueta de seis; sigue sin haber posiciones.
//
// `aqui` es a la vez el latido y la lectura: pedir la sala ES estar en ella. Tenerlo
// separado invitaría a mirar sin aparecer, y para eso está el modo oculto, que lo dice.
import { api } from "./client";

// `sitio` ES UNA ETIQUETA, NO UNA POSICION -«explanada», «templo»...-, y es lo unico que
// viaja de donde estas desde el 13 de septiembre de 2026. Lo que no sea una de las seis, el
// servidor lo guarda como nada.
export const presenciaAqui = async (avatar, oculto, sitio) =>
  (await api.post("/presencia/aqui", { avatar, oculto: !!oculto, sitio: sitio || null })).data;
export const presenciaSalgo = async () => (await api.post("/presencia/salgo")).data;
export const presenciaDigo = async (emoji) =>
  (await api.post("/presencia/digo", { emoji })).data;
export const presenciaRueda = async () => (await api.get("/presencia/rueda")).data;
